import React from 'react';
import './SevenSegmentBS.css';

const SevenSegmentDigit = ({ digit }) => {
  const segments = [
    digit !== '1' && digit !== '4',
    digit !== '5' && digit !== '6',
    digit !== '2',
    digit !== '1' && digit !== '4' && digit !== '7',
    (digit === '0' || digit === '2' || digit === '6' || digit === '8'),
    digit !== '1' && digit !== '2' && digit !== '3' && digit !== '7',
    digit !== '0' && digit !== '1' && digit !== '7',
  ];

  return (
    <div className="seven-segment-digit-bs">
      {segments.map((active, index) => (
        <div key={index} className={`segment-bs ${active ? 'active' : ''}`} />
      ))}
    </div>
  );
};

const SevenSegmentBS = ({ value }) => {
  const [minutes, unit] = value.split(' ');
  const paddedMinutes = minutes.padStart(4, '0');

  return (
    <div className="seven-segment-bs-display">
      {paddedMinutes.split('').map((digit, index) => (
        <SevenSegmentDigit key={index} digit={digit} />
      ))}
      <div className="unit-bs">{unit}</div>
    </div>
  );
};

export default SevenSegmentBS;